import { useRef } from 'react';
import { isEqual } from 'lodash';
import { deepClone, isEmpty } from '../../../../util/util';
import { INITIAL_PROVISION_AGREEMENT } from '../constants';

export function useAccountingFirmFormObserver() {
  const companyDetailRef = useRef<any>(null);

  const setCompanyDetail = (detail: any) => {
    companyDetailRef.current = detail ? JSON.parse(JSON.stringify(detail)) : null;
  };

  const getCompanyDetail = () => {
    return companyDetailRef.current ? JSON.parse(JSON.stringify(companyDetailRef.current)) : null;
  };

  const hasProvisionAgreementChanges = (_companyDetail: any, provisionAgreement: any) => {
    const defaultValue = deepClone(INITIAL_PROVISION_AGREEMENT);
    if (!_companyDetail['provisionAgreement']) {
      return !isEqual(defaultValue, provisionAgreement);
    }

    return !isEqual(_companyDetail['provisionAgreement'], provisionAgreement);
  };

  const hasChanges = (
    firmDetails: any,
    addressDetails: any,
    contractEffectiveFrom: any,
    invoiceEmailAddress: any,
    invoicingCostCenter: any,
    seniorConsultants: any,
    supervisors: any,
    invitationEmail: any,
    provisionAgreement: any,
    combinations: any,
  ) => {
    if (!firmDetails || !companyDetailRef.current || isEmpty(companyDetailRef.current)) {
      return false;
    }

    const _companyDetail = companyDetailRef.current || {};

    return (
      !isEqual(_companyDetail['name'], firmDetails.name) ||
      !isEqual(_companyDetail['organizationNumber'], firmDetails.organizationNumber) ||
      !isEqual(_companyDetail['status'], firmDetails.status) ||
      !isEqual(_companyDetail['address'], addressDetails) ||
      !isEqual(_companyDetail['contractEffectiveFrom'], contractEffectiveFrom) ||
      !isEqual(_companyDetail['invoiceEmailAddress'], invoiceEmailAddress) ||
      !isEqual(_companyDetail['invoicingCostCenter'], invoicingCostCenter) ||
      !isEqual(_companyDetail['seniorConsultants'], seniorConsultants) ||
      !isEqual(_companyDetail['supervisors'], supervisors) ||
      !isEqual(_companyDetail['invitationEmail'], invitationEmail) ||
      hasProvisionAgreementChanges(_companyDetail, provisionAgreement) ||
      !isEqual(_companyDetail['combinations'], combinations)
    );
  };

  return {
    setCompanyDetail,
    getCompanyDetail,
    hasChanges,
  };
}
